import axiosInstance from "../../utils/axiosInstance";
import { FORM_SUBMIT_URL, BASE_URL } from "../../../constants";
import { message } from "antd";
import { toast } from "react-toastify";

export const validateAndSubmitPolicaOsiguranja = async (
  values,
  selectedRecord,
  cleanup,
  update,
  transitionToUpdate,
  setIdPredPosEvid,
  setShowPotpisivanjeConfirmationModal,
  role,
  fetchEvidencijeTableData
) => {
  const valuesCopy = { ...values };

  delete valuesCopy.dokumentPoliceOsiguranja;
  delete valuesCopy.obavijestONastalimPromjenama;

  const URL = FORM_SUBMIT_URL[selectedRecord];

  const formData = new FormData();

  if (update) {
    const { idPredPosEvid, obrisaniDokumenti } = valuesCopy;

    formData.append("idPredPosEvid", idPredPosEvid);
    formData.append("obrisaniDokumenti", obrisaniDokumenti);
  }

  formData.append("policaOsiguranja", JSON.stringify(valuesCopy));

  if (values.obavijestONastalimPromjenama.length > 0) {
    values.obavijestONastalimPromjenama.map((attachment) =>
      formData.append("obavijestONastalimPromjenama", attachment.originFileObj)
    );
  }
  if (values.dokumentPoliceOsiguranja.length > 0) {
    values.dokumentPoliceOsiguranja.map((attachment) =>
      formData.append("dokumentPoliceOsiguranja", attachment.originFileObj)
    );
  }

  try {
    //nalazim treće od nazad mjesto u stringu i provjeravam je li zarez za polje premija, koliko ima zareza u polju, te je li zarez prvi znak
    const zarez = values.premijaZaRazdoblje.slice(-3,-2);
    let isNotZarez = (zarez == "," ? false : true);
    const numberZarez = (values.premijaZaRazdoblje.split(",").length - 1);
    const prviZnak = values.premijaZaRazdoblje.substring(0,1);
    let firstIsZarez = (prviZnak == "," ? true : false);
    //nalazim treće od nazad mjesto u stringu i provjeravam je li zarez za polje svota pokrića, koliko ima zareza u polju, te je li zarez prvi znak
    const zarezSvotaPokrica = values.svotaPokrica.slice(-3,-2);
    let isNotZarezSvotaPokrica = (zarezSvotaPokrica == "," ? false : true);
    const numberZarezSvotaPokrica = (values.svotaPokrica.split(",").length - 1);
    const prviZnakSvotaPokrica = values.svotaPokrica.substring(0,1);
    let firstIsZarezSvotaPokrica = (prviZnakSvotaPokrica == "," ? true : false);

    //ako polje premija ne sadrži točno jedan zarez ili se on ne nalazi na trećem od nazad mjestu 
    if(values.premijaZaRazdoblje.length>0 && (isNotZarez==true || numberZarez != 1 || firstIsZarez==true)) {
      toast.error("Format premije neispravan!", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    } else if(values.svotaPokrica.length>0 && (isNotZarezSvotaPokrica==true || numberZarezSvotaPokrica != 1  || firstIsZarezSvotaPokrica==true)) { 
      //ako polje svota pokrića ne sadrži točno jedan zarez ili se on ne nalazi na trećem od nazad mjestu 
      toast.error("Format svote pokrića neispravan!", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }else {
    if (!update) {
      const { data } = await axiosInstance.post(`${BASE_URL}${URL}`, formData);
      const { idPredPosEvid } = data;
      if (role === "ROLE_KORISNIK") {
        setIdPredPosEvid(idPredPosEvid);
        setShowPotpisivanjeConfirmationModal(true);
      }
    } else {
      await axiosInstance.patch(`${BASE_URL}${URL}`, formData);
    }

    toast.success("Posebna evidencija spremljena", {
      position: toast.POSITION.BOTTOM_RIGHT,
    });
    cleanup();
    fetchEvidencijeTableData();
  }
  } catch (e) {
    if (e.response.data.statusCode == 418) {
      transitionToUpdate();
    }
    if (e.response.data.msg) {
      toast.info(e.response.data.msg, {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    } else {
      toast.info("Nešto je pošlo po krivu. Molimo pokušajte ponovno!", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  }
};
